function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Box from '../Box';
import Text from '../Text';
import { HorizontalList } from './ListComponents/HorizontalList';
var LIST_TYPE = {
  HORIZONTAL_LIST: 'HORIZONTAL_LIST'
};

var Container = function Container(_ref) {
  var type = _ref.type,
      children = _ref.children,
      columnSpacing = _ref.columnSpacing,
      rowSpacing = _ref.rowSpacing,
      columns = _ref.columns,
      props = _objectWithoutPropertiesLoose(_ref, ["type", "children", "columnSpacing", "rowSpacing", "columns"]);

  switch (type) {
    case LIST_TYPE.HORIZONTAL_LIST:
      return /*#__PURE__*/React.createElement(HorizontalList, _extends({
        columnSpacing: columnSpacing,
        rowSpacing: rowSpacing,
        columns: columns,
        flexWrap: 'wrap'
      }, props), children);

    default:
      return /*#__PURE__*/React.createElement(Box, props, children);
  }
};

var EmptyState = function EmptyState(_ref2) {
  var emptyText = _ref2.emptyText;
  return /*#__PURE__*/React.createElement(Text.Light, {
    py: 6,
    textAlign: "center"
  }, emptyText);
};

var List = function List(_ref3) {
  var renderItem = _ref3.renderItem,
      items = _ref3.items,
      listType = _ref3.listType,
      columns = _ref3.columns,
      columnSpacing = _ref3.columnSpacing,
      rowSpacing = _ref3.rowSpacing,
      emptyText = _ref3.emptyText,
      restProps = _objectWithoutPropertiesLoose(_ref3, ["renderItem", "items", "listType", "columns", "columnSpacing", "rowSpacing", "emptyText"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    type: items.length > 0 ? listType : undefined,
    columns: columns,
    columnSpacing: columnSpacing,
    rowSpacing: rowSpacing
  }, restProps), items.map(function (item, index) {
    return React.cloneElement(renderItem(item, index));
  }), items.length === 0 && /*#__PURE__*/React.createElement(EmptyState, {
    emptyText: emptyText
  }));
};

List.propTypes = process.env.NODE_ENV !== "production" ? {
  renderItem: PropTypes.func,
  items: PropTypes.array,
  listType: PropTypes.oneOf(Object.values(LIST_TYPE)),
  emptyText: PropTypes.string
} : {};
List.defaultProps = {
  renderItem: function renderItem() {},
  items: [],
  emptyText: 'ไม่มีข้อมูล'
};
List.LIST_TYPE = LIST_TYPE;
export { List, LIST_TYPE };
export default List;